/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import AnalyticsChannelBase from './AnalyticsChannelBase';
import AnalyticsChannelGA4 from './AnalyticsChannelGA4';
import AnalyticsChannelGTM from './AnalyticsChannelGTM';
import { AnalyticsError, AnalyticsEvent } from './AnalyticsConfig';

class Analytics {
  private static _instance: Analytics;

  private channels: AnalyticsChannelBase[];

  private constructor() {
    this.channels = [new AnalyticsChannelGA4(), new AnalyticsChannelGTM()];
  }

  public static get instance() {
    return this._instance || (this._instance = new this());
  }

  public log(type: AnalyticsEvent, label?: string, additional?: string | number | boolean) {
    this.channels.forEach((channel) => {
      channel.log(type, label, additional);
    });
  }

  public error(type: AnalyticsError, message?: string) {
    this.channels.forEach((channel) => {
      channel.error(type, message);
    });
  }
}

export default Analytics.instance;
